import { MapPin, Palette, Maximize2, Square, Star, Type } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { cn } from '@/lib/utils';
import { Category } from './CategoryNavigation';

// Ikona frame s šipkami uvnitř
const FrameWithArrowsIcon = ({ className }: { className?: string }) => (
  <div className={cn("relative", className)}>
    <Square className="w-5 h-5" />
    <Maximize2 className="w-3 h-3 absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2" />
  </div>
);

interface MobileBottomNavProps {
  selectedCategory: Category;
  onCategorySelect: (category: Category) => void;
  selectedMapIconId?: string | null;
  onCloseMapIconEditor?: () => void;
}

const categories = [
  { id: 'map' as Category, icon: MapPin, labelKey: 'settings.map' },
  { id: 'style' as Category, icon: Palette, labelKey: 'settings.style' },
  { id: 'text' as Category, icon: Type, labelKey: 'settings.text' },
  { id: 'frames-and-size' as Category, icon: FrameWithArrowsIcon, labelKey: 'settings.framesAndSize' },
  { id: 'icons' as Category, icon: Star, labelKey: 'settings.icons' },
];

export function MobileBottomNav({ selectedCategory, onCategorySelect, selectedMapIconId, onCloseMapIconEditor }: MobileBottomNavProps) {
  const { t } = useTranslation();
  
  const handleCategoryClick = (category: Category) => {
    // Pokud je vybrána ikona v mapě a kliknu na kategorii 'icons', zrušit výběr ikony
    if (selectedMapIconId && category === 'icons' && onCloseMapIconEditor) {
      onCloseMapIconEditor();
    }
    onCategorySelect(category);
  };
  
  return (
    <div className="fixed bottom-0 left-0 right-0 z-30 bg-white-cream/95 backdrop-blur-lg border-t border-wood-warm/30 shadow-lg lg:hidden">
      <div className="flex items-center justify-around px-2 py-2 safe-area-inset-bottom">
        {categories.map((category) => {
          const IconComponent = category.icon;
          const isSelected = selectedCategory === category.id;
          
          return (
            <button
              key={category.id}
              onClick={() => handleCategoryClick(category.id)}
              className={cn(
                "flex flex-col items-center justify-center gap-1 px-3 py-2 rounded-xl transition-all duration-200 min-w-[60px]",
                isSelected 
                  ? "bg-green-dark text-white-pure shadow-md" 
                  : "text-charcoal-medium hover:text-charcoal-dark hover:bg-beige-warm active:bg-beige-warm"
              )}
              aria-label={t(category.labelKey)}
            >
              <IconComponent className={cn(
                "w-5 h-5 transition-transform",
                isSelected && "scale-110"
              )} />
              <span className={cn(
                "text-[10px] font-medium leading-tight",
                isSelected ? "text-white-pure" : "text-charcoal-medium"
              )}>
                {t(category.labelKey)}
              </span>
            </button>
          );
        })}
      </div>
    </div>
  );
}





